<template>
  <v-container  ref="barWrapper" fluid fill-height  ma-0 pa-0 >
    <loading-circle
      :show="loader"
    />
    <v-layout fill-height>
      <v-flex xs12 pa-0>
        <scroll-table
          :data="getTable"
          :options="options"
          :sortable="false"
          :translate="true"
          :subscribed="true"
          :hideValues="['undefined']"
          @select="(payload) => onDeviceSelect(payload)"
        />
      </v-flex>
    </v-layout>
    <device-bar
      :open="getDeviceBarOpen"
      @update=""
      @load-devices=""
      @close="() => {this.$store.dispatch('activeDevice', null)}"
    />
  </v-container>
</template>

<script>

import scrollArea from '@/nms/components/partials/scrollarea.vue'
import loadingCircle from '@/nms/components/partials/loader.vue'
import LocationTable from '@/nms/components/partials/scrolltable.vue'
import scrollTable from '@/nms/components/partials/scrolltable.vue'
import DeviceBar from '@/nms/pages/device/device-bar.vue'

import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapMutations, mapActions } = createNamespacedHelpers(
  'schemas',
)

export default {

  name: 'MAP_MODAL',

  components: {
    scrollArea,
    loadingCircle,
    LocationTable,
    scrollTable,
    DeviceBar,
  },

  props: {
    data: {
      type: Object,
      default: () => ({})
    },
  },

  data: () => ({
    loader: false,
    devices: [],
    schema: null,
    bar: {
      device: {
        open: false
      },
    },
    options: {
      columns: {
        text: {
          width: '40%'
        },
        timestamp: {
          width: '40%'
        },
        timestamp: {
          width: '40%'
        },
        actions: {
          width: '40%'
        },
        endpoint: {
          width: '40%'
        },
        check: {
          width: '20%'
        },
      },
    },
    filter: null,
    search: '',
    table: {
      columns: [
        {
          title: 'place',
          value: 'place',
          type: 'text',
          width: '30%'
        },
        {
          title: 'cabinet',
          value: 'cabinet',
          type: 'text',
          width: '20%'
        },
        {
          title: 'device',
          value: 'name',
          type: 'text',
          width: '40%'
        },
      ],
      rows: []
    },
  }),

  computed: {
    getData: function () {
      return this.data
    },

    getDeviceBarOpen: function () {
      // избавляемся от watcher
      const dev = this.$store.state.devices.activeDevice
      this.bar.device.open = (dev && dev.$id) ? true : false
      return this.bar.device.open
    },

    getTable: function () {
      let t = this.$merge({}, this.table)
      return t
    },

    ...mapGetters([
      'schemas'
    ]),
  },

  watch: {},

  created () {
    this.setup()
  },

  mounted () {},

  updated () {},

  beforeDestroy () {},

  methods: {

    ...mapActions([
      'openSchema'
    ]),

    setup: async function () {
      this.loadDevices()
      this.reset()
      this.statusUnsubscribe('MAP_MODAL')
      this.prepareTable()
    },

    loadDevices: async function () {
      try {
        this.setLoader('loadDevices', true)
        let data$ = await this.getData.getLinks({compute: 'is_used'})
        this.devices = []
        if(data$ && data$.length) {
          data$.forEach(child => {
            if(child.cls == 'device') {
              this.devices.push(child)
            }
          })
          this.setLoader('loadDevices', false)
        } else {
          this.setLoader('loadDevices', false)
        }
      }
      catch(err) {
        console.error('CATCH', this.$options.name, 'loadDevices', err)
        this.loader = false
      }
    },

    onDeviceSelect: async function (payload) {
      try {
        let query$ = {
          id: [payload.$id],
          notNull: true,
          data: {
            links: {
              flatten: false,
            }
          }
        }
        let device$ = await this.$bridge.cmdbQuery(query$)
        device$[0].children = device$[0].links
        await this.$store.dispatch('activeDevice', device$[0])
      }
      catch(err) {
        console.error('CATCH', this.$options.name, 'onDeviceSelect', err)
        this.loader = false
      }
    },

    setLoader: function(name, status) {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })

    },

    prepareTable: async function () {
      try {
          let locationTree = await this.getData.getLinks()
          let arr = []
          let subscribeArr = []

          const heapData = (arr$, data, parent) => {
            let parent$ = parent || this.data.name
            arr$.forEach(child => {
              let ownParent$ = child.cls == 'location' ? parent$ + ' / ' + child.name : parent$
              let row$ = {}
              if(child.cls == 'device') {
                row$.device = child
                row$.name = child.name
                row$.$id = child.$id
                row$.place = ownParent$
                row$.cabinet = data.cls == 'cabinet' ? data.name : this.$t('out of cabinet')
                arr.push(row$)
                subscribeArr.push(child)
              }
              if(child.cls == 'module' && data.cls == 'location') {
                row$.device = child
                row$.name = child.name
                row$.$id = child.$id
                row$.place = ownParent$
                row$.cabinet = this.$t('out of device')
                arr.push(row$)
                subscribeArr.push(child)
              }
              if(child.children && child.children.length) {
                heapData(child.children, child, ownParent$)
              }
            })
          }
          console.log(this.$options.name, 'PREPARE_TABLE locationTree', locationTree)
          heapData(locationTree, this.data)
          console.log(this.$options.name, 'PREPARE_TABLE', arr)
          this.table.rows = arr
          this.loader = false
          this.statusSubscribe(subscribeArr, 'MAP_MODAL')
      }
      catch(err) {
        console.error('CATCH', this.$options.name, 'prepareTable', err)
        this.loader = false
      }
    },

    statusSubscribe: async function (arr, group) {
      this.$store.dispatch('measuresSubscribeInit', {
        name: 'addStatus',
        group: group,
        listener: 'status'
      })
      if(arr.length) {
        arr.forEach((item, i) => {
          if(item.$id) {
            this.$store.dispatch('addStatusKey',item)
          }
        });
        await this.$bridge.subscribe(arr.map(obj => obj.$id))
      }
    },

    subscribeHandler: function (e) {
      if (e.$id) {
        this.$store.dispatch('addStatus', e)
      }
    },

    statusUnsubscribe: function (group) {
      this.$store.dispatch('measuresSubscribeClose', {
        handler: this.subscribeHandler,
        group: group,
        listener: 'status'
      })
    },

    reset: function () {
      this.table.rows = []
    }
  }
}
</script>

<style scoped lang="less">
.mnemo {
  width: 100%;
  height: 100%;
  display: flex;
}
.diagram {
  width: 100%;
  height: 100%;
}
.tag-nav-wrapper {
  padding: 0;
  flex-grow: 0;
  height: 37px;

  overflow-y: visible;
}
.block-container {
  width: 100%;
  // height: 650px;
  height: 100%;
  // height: ~'calc(100% - 50px)';
  border: 1px solid black;
  padding: 0;
}
.menu {
  position: absolute;
  top: 0;
  left: 0;
  width: 400px;
  height: 100%;
  background-color: white;
  border: 1px solid black;
  padding: 10px;
  padding-top: 30px;
  z-index: 10;
}
.img {
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}

.link {
  display: inline-block;
  color: #000;
  text-decoration: none;
}

.link::after {
  content: '';
  display: block;
  width: 0;
  height: 2px;
  background: #000;
  transition: width 0.3s;
}

.link:hover::after {
  width: 100%;
  //transition: width .3s;
}
</style>
